import { IonContent } from '@ionic/react';
import OrderDetailsScreen, { IOrderDetailsPage, RedirectStatus } from '../../../../pages/OrderDetailsScreen';
import { FC, useEffect, useState } from 'react';
import {
  ORDER_PAYMENT_STATUSES,
  PushNotificationStatus,
  REDUX_STORE_SLICES,
} from '../../../../services/exports/Constants';
import ModalWrapper from '../../components/modals/ModalWrapper';
import ModalHeader from '../../components/modals/ModalHeader';
import { IModal } from '../../router/ModalRouter';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';
import RequestPushNotificationsPermitAlert from '../../alerts/request-push-notifications-permit';
import { useTranslation } from 'react-i18next';
import RequestAppReviewAlert from '../../alerts/request-app-review';
import useStore from '../../../../hooks/store/useStore';
import { FeatureFlags } from '../../exports/Enums';
import OrderTracker from '../../../../components-library/order/OrderTracker';

const OrderTrackerPage: FC<Partial<IModal> & IOrderDetailsPage> = ({ closeModal, ...rest }): JSX.Element => {
  const { t } = useTranslation(null, {
    keyPrefix: 'Modules:Mobile:Modals:OrderTracker:OrderTrackerPage',
  });
  const { redirect_status } = rest;
  const { appReviewRequested } = useStore<REDUX_STORE_SLICES.MOBILE_APP>(REDUX_STORE_SLICES.MOBILE_APP);
  const [paymentStatus, setPaymentStatus] = useState<ORDER_PAYMENT_STATUSES>(null);
  const { pushNotificationsStatus, hasFeature } = useMobileApp();
  const [showPushNotificationsPermitAlert, setShowPushNotificationsPermitAlert] = useState<boolean>(false);
  const [showAppReviewAlert, setShowAppReviewAlert] = useState<boolean>(false);

  const dispatchAlert = (alertFn: () => void) => setTimeout(alertFn, 1000);

  const throwAlerts = (): void => {
    if (pushNotificationsStatus === PushNotificationStatus.Undetermined) {
      dispatchAlert(() => setShowPushNotificationsPermitAlert(true));
      return;
    }

    if (!appReviewRequested && hasFeature(FeatureFlags.AppReview)) {
      dispatchAlert(() => setShowAppReviewAlert(true));
      return;
    }
  };

  useEffect(() => {
    if (redirect_status === RedirectStatus.failed || !redirect_status) {
      return;
    }
    throwAlerts();
  }, []);

  return (
    <>
      <ModalWrapper className="relative h-screen overflow-scroll safe-area">
        <ModalHeader title={t('title')} onClose={closeModal} type="page" />
        <IonContent>
          <OrderDetailsScreen {...rest} closeModal={closeModal} onChangePaymentStatus={setPaymentStatus} />
        </IonContent>
        {paymentStatus && paymentStatus !== ORDER_PAYMENT_STATUSES.PENDING && (
          <div className="fixed bottom-0 w-full pt-sm safe-area-bottom bg-white px-md rounded-t-2xl shadow-[0_-4px_20px_rgba(0,0,0,0.15)]">
            <OrderTracker className="pb-md" />
          </div>
        )}
      </ModalWrapper>
      <RequestPushNotificationsPermitAlert
        isOpen={showPushNotificationsPermitAlert}
        onClose={() => setShowPushNotificationsPermitAlert(false)}
      />
      <RequestAppReviewAlert isOpen={showAppReviewAlert} onClose={() => setShowAppReviewAlert(false)} />
    </>
  );
};

export default OrderTrackerPage;
